// A game served from the developer's machine is not behind our edge, so nothing
// rewrites its SDK URL to this stack's build; its loader would fall back to
// production's. The host page knows the pin (SDK_JS_FILE) and hands it to the
// plugin, which passes it down on the iframe URL. The loader honours a full
// URL only on localhost, which is exactly and only where this applies (#112).

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

export function withSdkParam(gameUrl, sdkJsFile) {
  if (!sdkJsFile) return gameUrl;
  let url;
  try {
    url = new URL(gameUrl);
  } catch {
    return gameUrl;
  }
  if (!LOCAL_HOSTS.includes(url.hostname)) return gameUrl;
  // A developer who typed ?g8sdk= themselves knows better than the host page.
  if (url.searchParams.has('g8sdk')) return gameUrl;
  url.searchParams.set('g8sdk', sdkJsFile);
  return url.href;
}
